// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Discord = function Discord(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M6.7 7.66a.77.77 0 00-.73.8H6a.77.77 0 00.73.8.77.77 0 00.74-.79.76.76 0 00-.72-.8zm2.62 0a.77.77 0 00-.73.8.74.74 0 001.47.16v-.16a.77.77 0 00-.73-.8z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M12.81 1.64H3.19a1.49 1.49 0 00-1.47 1.48v9.7a1.46 1.46 0 001.46 1.48h8.15L11 13l.9.85.9.81L14.28 16V3.12a1.49 1.49 0 00-1.47-1.48zM10 11l-.48-.58a2.31 2.31 0 001.3-.9A4.23 4.23 0 0110 10a5 5 0 01-1 .31 5.06 5.06 0 01-1.9 0A6.74 6.74 0 016 10c-.16-.09-.33-.18-.48-.28H5.5a1.39 1.39 0 01-.19-.15 2.26 2.26 0 001.25.85l-.47.6a2.61 2.61 0 01-2.24-1.1 9.67 9.67 0 011-4.18 3.43 3.43 0 012-.75l.15.08A4.91 4.91 0 005.08 6l.43-.2a4.91 4.91 0 011.59-.44h.13a5.78 5.78 0 011.44 0 5.93 5.93 0 012.17.69A4.7 4.7 0 009 5.15L9.14 5a3.54 3.54 0 012 .76 9.66 9.66 0 011 4.18A2.62 2.62 0 0110 11.06z"
    }))
  );
};

export default Discord;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Discord.js
// module id = 996
// module chunks = 0